import React from 'react'
import { useStateValue } from '@State'
import { PeopleTables } from './PeopleTables'
import { SectionsTable } from './SectionsTable'

export const PeopleContainer = () => {
  const [currentState] = useStateValue()

  return (
    <div className="p-3">
      <h1 className="me-course-title">{currentState.courseTitle}</h1>
      <h2 className="me-page-title">People</h2>
      <SectionsTable tableName="section" page={currentState.currentSectionPage} />
      <PeopleTables />
    </div>
  )
}
